import React, { useMemo } from 'react'
import { ensureString, getHomeFullImageCallout, logEvent } from '../../Utils'
import { CardConStyle } from './styles'
import { Img } from '../Image/Img'
import { ANALYTICS_TAGS } from '../../Constant'
import { Lk } from '../Links/Lk'
import { BrazeContentCard, useBrazeContentCards } from '../../Hooks'
import { DefaultCardData } from '../../Constant/callouts'

type CalloutProps = {
  location: string
  cardData?: DefaultCardData | BrazeContentCard
}

export const FullImageCard: React.FC<React.PropsWithChildren<CalloutProps>> = ({
  location,
  cardData,
}) => {
  const { logContentCardClick } = useBrazeContentCards()

  const card = useMemo(() => {
    if (!cardData) {
      return getHomeFullImageCallout(location)
    }

    //Braze Content Cards have extras field
    if ('extras' in cardData) {
      return {
        id: cardData.id,
        title: cardData.title,
        imageUrl: cardData.imageUrl,
        url: cardData.url,
        linkText: ensureString(cardData?.linkText) ?? 'Go Now',
        location: location,
      }
    }
    return cardData
  }, [cardData, location])

  const handleClick = async () => {
    await Promise.all([
      logContentCardClick(card.id),
      logEvent(ANALYTICS_TAGS.callout_card_click, {
        card_id: card.id,
        title: card.title,
        section: 'home_callout',
        card_location: location,
        btn_text: card.linkText,
        link: card.url,
      }),
    ])
  }

  const linkAriaLabel = `${card?.linkText ?? 'Go Now'} - ${card?.title ?? 'Details'}`

  if (card?.url) {
    return (
      <Lk link={card.url} alt={linkAriaLabel} onBeforeNavigate={handleClick}>
        <CardConStyle>
          {card.imageUrl && (
            <Img src={card.imageUrl} alt={card.title ?? 'Card Featured'} />
          )}
          <div className="btn">{`${card?.linkText ?? 'Go Now'}`}</div>
        </CardConStyle>
      </Lk>
    )
  }

  return (
    <CardConStyle>
      {card.imageUrl && <Img src={card.imageUrl} alt={card.title ?? 'Card Featured'} />}
      <div>{`${card?.linkText ?? 'Go Now'}`}</div>
    </CardConStyle>
  )
}
